import React from "react";
import { useQuery } from "react-query";
import { Box, Typography, Paper, CircularProgress, Avatar, Tooltip } from "@mui/material";
import moment from "moment";
import { QK } from "../../../base/qk";
import { getEmployeesMonthTimeline, getEmployeesWeekTimeline } from "../../../api/services/TimeLine/timeLine";

const ExtendedTimelineView = ({ selectedDate, viewType }) => {
  const isWeek = viewType === "week";
  const timelineStart = isWeek ? moment(selectedDate).startOf("isoWeek") : moment(selectedDate).startOf("month");
  const totalDays = isWeek ? 14 : moment(selectedDate).daysInMonth();
  const columns = Array.from({ length: totalDays }, (_, i) => i);

  const { data: timelineResponse, isLoading } = useQuery(
    [QK.dayTimelineData, selectedDate, viewType],
    () => isWeek ? getEmployeesWeekTimeline(selectedDate) : getEmployeesMonthTimeline(selectedDate),
    { enabled: !!selectedDate, refetchOnWindowFocus: false, keepPreviousData: true }
  );

  if (isLoading && !timelineResponse) {
    return (
      <Box sx={{ height: 400, display: "flex", alignItems: "center", justifyContent: "center" }}>
        <CircularProgress size={28} thickness={4} />
      </Box>
    );
  }

  const resources = timelineResponse?.data || [];
  const COLUMN_WIDTH = 100; // প্রতিটি দিনের উইডথ ফিক্সড করলাম

  return (
    <Paper elevation={0} sx={{ height: "calc(100vh - 180px)", borderRadius: "12px", border: "1px solid #e5e7eb", overflow: "hidden" }}>
      <Box sx={{ height: "100%", overflow: "auto" }}>
        
        {/* কন্টেইনার উইডথ ডাইনামিক করা হলো */}
        <Box sx={{ width: 180 + (totalDays * COLUMN_WIDTH), position: 'relative' }}>
          
          {/* HEADER */}
          <Box sx={{ display: "flex", position: "sticky", top: 0, zIndex: 1000, bgcolor: "#f8fafc", borderBottom: "1px solid #e5e7eb" }}>
            <Box sx={{ width: 180, px: 2, py: 1.5, position: "sticky", left: 0, zIndex: 1100, bgcolor: "#f8fafc", borderRight: "1px solid #e5e7eb" }}>
              <Typography sx={{ fontSize: "11px", fontWeight: 800, color: "#64748b" }}>STAFF</Typography>
            </Box>
            {columns.map((col) => {
              const dateObj = moment(timelineStart).add(col, "days");
              return (
                <Box key={col} sx={{ width: COLUMN_WIDTH, py: 1, textAlign: "center", borderRight: "1px solid #f1f5f9" }}>
                  <Typography sx={{ fontSize: "10px", color: "#64748b" }}>{dateObj.format("ddd")}</Typography>
                  <Typography sx={{ fontSize: "12px", fontWeight: 700 }}>{dateObj.format("DD")}</Typography>
                </Box>
              );
            })}
          </Box>

          {/* ROWS */}
          {resources.map((row, rowIndex) => {
            // জবের ইনডেক্সিং গ্রুপিং
            const tasksByDay = {};
            row.tasks?.forEach((task) => {
              if (!tasksByDay[task.day_index]) tasksByDay[task.day_index] = [];
              tasksByDay[task.day_index].push(task);
            });

            return (
              <Box key={row.resource_id} sx={{ display: "flex", borderBottom: "1px solid #f1f5f9", zIndex: resources.length - rowIndex, position: 'relative' }}>
                
                {/* স্টিকি স্টাফ সেল */}
                <Box sx={{ width: 180, px: 2, py: 1, position: "sticky", left: 0, zIndex: 50, bgcolor: "white", borderRight: "1px solid #e5e7eb", display: "flex", alignItems: "center", gap: 1 }}>
                  <Avatar sx={{ width: 28, height: 28, fontSize: "11px", bgcolor: "#6366f1" }}>{row.resource_name?.[0]}</Avatar>
                  <Typography sx={{ fontSize: "12px", fontWeight: 600, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                    {row.resource_name}
                  </Typography>
                </Box>

                {/* টাইমলাইন ডাটা সেলস */}
                <Box sx={{ display: "flex" }}>
                  {columns.map((c) => (
                    <Box key={c} sx={{ 
                      width: COLUMN_WIDTH, 
                      minHeight: 70, 
                      p: 0.5, 
                      borderRight: "1px solid #f8fafc", 
                      display: 'flex', 
                      flexDirection: 'column', 
                      gap: 0.5,
                      bgcolor: tasksByDay[c] ? 'transparent' : '#fafafa44' // খালি দিনগুলো আলাদা দেখাবে
                    }}>
                      {tasksByDay[c]?.map((task) => (
                        <Tooltip key={task.id} arrow title={`${task.client_name} (${task.scheduled})`}>
                          <Box sx={{
                            px: 1, py: 0.5, borderRadius: "4px",
                            backgroundColor: `${task.display_color || "#3b82f6"}15`,
                            borderLeft: `3px solid ${task.display_color || "#3b82f6"}`,
                            cursor: "pointer"
                          }}>
                            <Typography sx={{ fontSize: "9px", fontWeight: 700, color: task.display_color }}>
                              {task.scheduled}
                            </Typography>
                          </Box>
                        </Tooltip>
                      ))}
                    </Box>
                  ))}
                </Box>
              </Box>
            );
          })}
        </Box>
      </Box>
    </Paper>
  );
};

export default ExtendedTimelineView;